import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Preloader from '../../../components/common/Preloader';
import { isLoading } from '../../../modules/events/selectors';
import { updateSubscriptions } from '../../../modules/livescore/actions';
import getDatesRange from '../../../utils/dates/getDatesRange';
import CompetitionList from '../../common/CompetitionList';
import FormMessage from '../../FormMessage';
import { competitionVisible, viewEnter, viewLeave } from '../actions';
import EventTile from '../EventTile';

export class Events extends React.Component {
  componentDidMount() {
    this.props.viewEnter();
  }

  componentWillUnmount() {
    this.props.viewLeave();
  }

  render() {
    const { loading, onAccordionChange } = this.props;
    const [{ dayName, dayNumber, month }] = getDatesRange(0, 0);

    return (
      <div className="live-scores">
        <div className="live-scores__header">
          <div className="live-scores__date">
            <b>{dayName}</b>, {dayNumber} {month}
          </div>
          <div className="live-scores__message-container">
            <FormMessage className="live-scores__message" slotId="live_events" />
          </div>
        </div>
        <div className="live-scores__main">
          {loading ? (
            <div className="live-scores__preloader">
              <Preloader darkBackground>Loading events...</Preloader>
            </div>
          ) : (
            <CompetitionList
              event={(eventId) => <EventTile key={eventId} eventId={eventId} />}
              onAccordionChange={onAccordionChange}
            />
          )}
        </div>
      </div>
    );
  }
}

Events.propTypes = {
  viewEnter: PropTypes.func.isRequired,
  viewLeave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  onAccordionChange: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  loading: isLoading(state)
});

export const mapDispatchToProps = dispatch => ({
  viewEnter: (...params) => dispatch(viewEnter(...params)),
  viewLeave: (...params) => dispatch(viewLeave(...params)),
  onAccordionChange: (...params) => {
    dispatch(competitionVisible(...params));
    dispatch(updateSubscriptions(...params));
  }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Events)
);
